import { useAppSelector } from "../../redux/hooks";
import { getUserRole } from "../../redux/selectors";

/**
 * @param {string} role - The role to check against the user's role.
 * @returns {boolean} - True if the user has the role, false otherwise.
 * @description - Checks if the user has the role.
 */

function hasRole(nameRole: string) {
  const role: any = useAppSelector(getUserRole);
  return nameRole === role;
}

export default hasRole;
